export default __webpack_public_path__ + "static/azalea-logo-5af733b03f315e069a47a19cbf1889fb.svg";